import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from './app/app/router';
import { ApolloProvider } from '@apollo/client';
import { initApp } from './init-app';
import 'overlayscrollbars/overlayscrollbars.css';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initApp().then(() => {
  root.render(
    <StrictMode>
      <ApolloProvider client={enrollmentApolloClient}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </StrictMode>
  );
});
// trigger
